module.exports = __webpack_public_path__ + "static/media/testkit5.eba36b4f.jpg";